import React from 'react';

export function ResearchProject(props){
  return <>
	<p className="sectionHeading1">Research Project</p>
	<p className="normalText">Fund as a Research Project until Product Market Match is established. This means that the effort should NOT be represented as a business to investors.  It also means that the effort could enjoy substantial funding, but funding that is NOT based upon any implied rate of return.</p>
	</>
}